import { default as indexj218sa44TCMeta } from "/vercel/path0/pages/activations/index.vue?macro=true";
import { default as _91id_93RAJnYaYSp1Meta } from "/vercel/path0/pages/broadcasts/[id].vue?macro=true";
import { default as indexV00pHVXLZvMeta } from "/vercel/path0/pages/broadcasts/index.vue?macro=true";
import { default as rateskDDG6T7AurMeta } from "/vercel/path0/pages/broadcasts/rates.vue?macro=true";
import { default as segments5HydWTRxQeMeta } from "/vercel/path0/pages/broadcasts/segments.vue?macro=true";
import { default as suppressions41dKsSzdVPMeta } from "/vercel/path0/pages/broadcasts/suppressions.vue?macro=true";
import { default as templatesCAPDr72GwOMeta } from "/vercel/path0/pages/broadcasts/templates.vue?macro=true";
import { default as indexuxCnAYUYm0Meta } from "/vercel/path0/pages/bulk-activations/index.vue?macro=true";
import { default as _91id_93FTZGUi5HAFMeta } from "/vercel/path0/pages/call/[id].vue?macro=true";
import { default as _91id_93ryOa94SHRvMeta } from "/vercel/path0/pages/calls/[id].vue?macro=true";
import { default as index83WcuKKWSwMeta } from "/vercel/path0/pages/calls/index.vue?macro=true";
import { default as calls5zalHHdL4EMeta } from "/vercel/path0/pages/calls.vue?macro=true";
import { default as indexmg1CdtqskNMeta } from "/vercel/path0/pages/coupons/index.vue?macro=true";
import { default as indexGucEoQqdjZMeta } from "/vercel/path0/pages/credentials/index.vue?macro=true";
import { default as _91id_93YFKWp2r25hMeta } from "/vercel/path0/pages/customers/[id].vue?macro=true";
import { default as indexs9KBIDgIMmMeta } from "/vercel/path0/pages/customers/index.vue?macro=true";
import { default as customersFnTFI2NcMYMeta } from "/vercel/path0/pages/customers.vue?macro=true";
import { default as index6K90dA4GwVMeta } from "/vercel/path0/pages/distributors/index.vue?macro=true";
import { default as _91id_93caSVL5ywX6Meta } from "/vercel/path0/pages/families/[id].vue?macro=true";
import { default as indexlnJqahZSogMeta } from "/vercel/path0/pages/field-posts/[id]/index.vue?macro=true";
import { default as _91iid_93kKcUuqGlq7Meta } from "/vercel/path0/pages/field-posts/[id]/interventions/[iid].vue?macro=true";
import { default as newUJDw7NQtVXMeta } from "/vercel/path0/pages/field-posts/[id]/interventions/new.vue?macro=true";
import { default as indexhGdnMdBQIJMeta } from "/vercel/path0/pages/field-posts/index.vue?macro=true";
import { default as indexe9Brt5DfdhMeta } from "/vercel/path0/pages/index.vue?macro=true";
import { default as summaryw9kPgb09MjMeta } from "/vercel/path0/pages/intervention/summary.vue?macro=true";
import { default as _91id_93iLwXZpucciMeta } from "/vercel/path0/pages/invoices/partners/[id].vue?macro=true";
import { default as index6zufjfFsdpMeta } from "/vercel/path0/pages/invoices/partners/index.vue?macro=true";
import { default as _91id_93zA9Q6fcuDNMeta } from "/vercel/path0/pages/invoices/providers/[id].vue?macro=true";
import { default as indexrHd2qMcmoUMeta } from "/vercel/path0/pages/invoices/providers/index.vue?macro=true";
import { default as invoicesOsO5xW78nEMeta } from "/vercel/path0/pages/invoices.vue?macro=true";
import { default as logint0AWlhQgM0Meta } from "/vercel/path0/pages/login.vue?macro=true";
import { default as indexYm59oj1SLUMeta } from "/vercel/path0/pages/partners/index.vue?macro=true";
import { default as forgotaWbLRONbBIMeta } from "/vercel/path0/pages/password/forgot.vue?macro=true";
import { default as resethWbKa6yAgnMeta } from "/vercel/path0/pages/password/reset.vue?macro=true";
import { default as verifyPiQwSCcsB1Meta } from "/vercel/path0/pages/password/verify.vue?macro=true";
import { default as _91id_93IrdWkC0qDNMeta } from "/vercel/path0/pages/payments/[id].vue?macro=true";
import { default as indexLuCZoHS5xNMeta } from "/vercel/path0/pages/payments/index.vue?macro=true";
import { default as indexGmBGSTDz3PMeta } from "/vercel/path0/pages/reports/index.vue?macro=true";
import { default as field_45postsgruasRTqaaMeta } from "/vercel/path0/pages/settings/field-posts.vue?macro=true";
import { default as optionsBIMxQezTTkMeta } from "/vercel/path0/pages/settings/options.vue?macro=true";
import { default as productsuQXr0fzq6aMeta } from "/vercel/path0/pages/settings/products.vue?macro=true";
import { default as providersk3w8VFccXoMeta } from "/vercel/path0/pages/settings/providers.vue?macro=true";
import { default as usersh4j5PhVKwFMeta } from "/vercel/path0/pages/settings/users.vue?macro=true";
import { default as verifyMlHSZdr9flMeta } from "/vercel/path0/pages/settings/verify.vue?macro=true";
import { default as settingsyZZu4Rd1aAMeta } from "/vercel/path0/pages/settings.vue?macro=true";
import { default as indexuj64qDKGynMeta } from "/vercel/path0/pages/telemedicine/doctors/[id]/index.vue?macro=true";
import { default as scheduleseHmwTKtEfMeta } from "/vercel/path0/pages/telemedicine/doctors/[id]/schedule.vue?macro=true";
import { default as indexZ79RIZiHMxMeta } from "/vercel/path0/pages/telemedicine/doctors/index.vue?macro=true";
import { default as indexOzhQKgPhzjMeta } from "/vercel/path0/pages/telemedicine/index.vue?macro=true";
import { default as profileTn0cRqXeAoMeta } from "/vercel/path0/pages/telemedicine/profile.vue?macro=true";
import { default as schedulecvKCCGt34GMeta } from "/vercel/path0/pages/telemedicine/schedule.vue?macro=true";
import { default as specialtiesLYpcaOE6QIMeta } from "/vercel/path0/pages/telemedicine/specialties.vue?macro=true";
import { default as telemedicineV1sC0qjAtGMeta } from "/vercel/path0/pages/telemedicine.vue?macro=true";
import { default as viewPrQRR6i1T0Meta } from "/vercel/path0/pages/transport/view.vue?macro=true";
import { default as _91id_93oxadfVMr34Meta } from "/vercel/path0/pages/transports/[id].vue?macro=true";
import { default as createyIkZ1jIXbuMeta } from "/vercel/path0/pages/transports/create.vue?macro=true";
import { default as indexWVnZNZrOTzMeta } from "/vercel/path0/pages/transports/index.vue?macro=true";
import { default as indexOXtObJcgq9Meta } from "/vercel/path0/pages/users/index.vue?macro=true";
export default [
  {
    name: indexj218sa44TCMeta?.name ?? "activations",
    path: indexj218sa44TCMeta?.path ?? "/activations",
    meta: indexj218sa44TCMeta || {},
    alias: indexj218sa44TCMeta?.alias || [],
    redirect: indexj218sa44TCMeta?.redirect,
    component: () => import("/vercel/path0/pages/activations/index.vue").then(m => m.default || m)
  },
  {
    name: _91id_93RAJnYaYSp1Meta?.name ?? "broadcasts-id",
    path: _91id_93RAJnYaYSp1Meta?.path ?? "/broadcasts/:id()",
    meta: _91id_93RAJnYaYSp1Meta || {},
    alias: _91id_93RAJnYaYSp1Meta?.alias || [],
    redirect: _91id_93RAJnYaYSp1Meta?.redirect,
    component: () => import("/vercel/path0/pages/broadcasts/[id].vue").then(m => m.default || m)
  },
  {
    name: indexV00pHVXLZvMeta?.name ?? "broadcasts",
    path: indexV00pHVXLZvMeta?.path ?? "/broadcasts",
    meta: indexV00pHVXLZvMeta || {},
    alias: indexV00pHVXLZvMeta?.alias || [],
    redirect: indexV00pHVXLZvMeta?.redirect,
    component: () => import("/vercel/path0/pages/broadcasts/index.vue").then(m => m.default || m)
  },
  {
    name: rateskDDG6T7AurMeta?.name ?? "broadcasts-rates",
    path: rateskDDG6T7AurMeta?.path ?? "/broadcasts/rates",
    meta: rateskDDG6T7AurMeta || {},
    alias: rateskDDG6T7AurMeta?.alias || [],
    redirect: rateskDDG6T7AurMeta?.redirect,
    component: () => import("/vercel/path0/pages/broadcasts/rates.vue").then(m => m.default || m)
  },
  {
    name: segments5HydWTRxQeMeta?.name ?? "broadcasts-segments",
    path: segments5HydWTRxQeMeta?.path ?? "/broadcasts/segments",
    meta: segments5HydWTRxQeMeta || {},
    alias: segments5HydWTRxQeMeta?.alias || [],
    redirect: segments5HydWTRxQeMeta?.redirect,
    component: () => import("/vercel/path0/pages/broadcasts/segments.vue").then(m => m.default || m)
  },
  {
    name: suppressions41dKsSzdVPMeta?.name ?? "broadcasts-suppressions",
    path: suppressions41dKsSzdVPMeta?.path ?? "/broadcasts/suppressions",
    meta: suppressions41dKsSzdVPMeta || {},
    alias: suppressions41dKsSzdVPMeta?.alias || [],
    redirect: suppressions41dKsSzdVPMeta?.redirect,
    component: () => import("/vercel/path0/pages/broadcasts/suppressions.vue").then(m => m.default || m)
  },
  {
    name: templatesCAPDr72GwOMeta?.name ?? "broadcasts-templates",
    path: templatesCAPDr72GwOMeta?.path ?? "/broadcasts/templates",
    meta: templatesCAPDr72GwOMeta || {},
    alias: templatesCAPDr72GwOMeta?.alias || [],
    redirect: templatesCAPDr72GwOMeta?.redirect,
    component: () => import("/vercel/path0/pages/broadcasts/templates.vue").then(m => m.default || m)
  },
  {
    name: indexuxCnAYUYm0Meta?.name ?? "bulk-activations",
    path: indexuxCnAYUYm0Meta?.path ?? "/bulk-activations",
    meta: indexuxCnAYUYm0Meta || {},
    alias: indexuxCnAYUYm0Meta?.alias || [],
    redirect: indexuxCnAYUYm0Meta?.redirect,
    component: () => import("/vercel/path0/pages/bulk-activations/index.vue").then(m => m.default || m)
  },
  {
    name: _91id_93FTZGUi5HAFMeta?.name ?? "call-id",
    path: _91id_93FTZGUi5HAFMeta?.path ?? "/call/:id()",
    meta: _91id_93FTZGUi5HAFMeta || {},
    alias: _91id_93FTZGUi5HAFMeta?.alias || [],
    redirect: _91id_93FTZGUi5HAFMeta?.redirect,
    component: () => import("/vercel/path0/pages/call/[id].vue").then(m => m.default || m)
  },
  {
    name: calls5zalHHdL4EMeta?.name ?? undefined,
    path: calls5zalHHdL4EMeta?.path ?? "/calls",
    meta: calls5zalHHdL4EMeta || {},
    alias: calls5zalHHdL4EMeta?.alias || [],
    redirect: calls5zalHHdL4EMeta?.redirect,
    component: () => import("/vercel/path0/pages/calls.vue").then(m => m.default || m),
    children: [
  {
    name: _91id_93ryOa94SHRvMeta?.name ?? "calls-id",
    path: _91id_93ryOa94SHRvMeta?.path ?? ":id()",
    meta: _91id_93ryOa94SHRvMeta || {},
    alias: _91id_93ryOa94SHRvMeta?.alias || [],
    redirect: _91id_93ryOa94SHRvMeta?.redirect,
    component: () => import("/vercel/path0/pages/calls/[id].vue").then(m => m.default || m)
  },
  {
    name: index83WcuKKWSwMeta?.name ?? "calls",
    path: index83WcuKKWSwMeta?.path ?? "",
    meta: index83WcuKKWSwMeta || {},
    alias: index83WcuKKWSwMeta?.alias || [],
    redirect: index83WcuKKWSwMeta?.redirect,
    component: () => import("/vercel/path0/pages/calls/index.vue").then(m => m.default || m)
  }
]
  },
  {
    name: indexmg1CdtqskNMeta?.name ?? "coupons",
    path: indexmg1CdtqskNMeta?.path ?? "/coupons",
    meta: indexmg1CdtqskNMeta || {},
    alias: indexmg1CdtqskNMeta?.alias || [],
    redirect: indexmg1CdtqskNMeta?.redirect,
    component: () => import("/vercel/path0/pages/coupons/index.vue").then(m => m.default || m)
  },
  {
    name: indexGucEoQqdjZMeta?.name ?? "credentials",
    path: indexGucEoQqdjZMeta?.path ?? "/credentials",
    meta: indexGucEoQqdjZMeta || {},
    alias: indexGucEoQqdjZMeta?.alias || [],
    redirect: indexGucEoQqdjZMeta?.redirect,
    component: () => import("/vercel/path0/pages/credentials/index.vue").then(m => m.default || m)
  },
  {
    name: customersFnTFI2NcMYMeta?.name ?? undefined,
    path: customersFnTFI2NcMYMeta?.path ?? "/customers",
    meta: customersFnTFI2NcMYMeta || {},
    alias: customersFnTFI2NcMYMeta?.alias || [],
    redirect: customersFnTFI2NcMYMeta?.redirect,
    component: () => import("/vercel/path0/pages/customers.vue").then(m => m.default || m),
    children: [
  {
    name: _91id_93YFKWp2r25hMeta?.name ?? "customers-id",
    path: _91id_93YFKWp2r25hMeta?.path ?? ":id()",
    meta: _91id_93YFKWp2r25hMeta || {},
    alias: _91id_93YFKWp2r25hMeta?.alias || [],
    redirect: _91id_93YFKWp2r25hMeta?.redirect,
    component: () => import("/vercel/path0/pages/customers/[id].vue").then(m => m.default || m)
  },
  {
    name: indexs9KBIDgIMmMeta?.name ?? "customers",
    path: indexs9KBIDgIMmMeta?.path ?? "",
    meta: indexs9KBIDgIMmMeta || {},
    alias: indexs9KBIDgIMmMeta?.alias || [],
    redirect: indexs9KBIDgIMmMeta?.redirect,
    component: () => import("/vercel/path0/pages/customers/index.vue").then(m => m.default || m)
  }
]
  },
  {
    name: index6K90dA4GwVMeta?.name ?? "distributors",
    path: index6K90dA4GwVMeta?.path ?? "/distributors",
    meta: index6K90dA4GwVMeta || {},
    alias: index6K90dA4GwVMeta?.alias || [],
    redirect: index6K90dA4GwVMeta?.redirect,
    component: () => import("/vercel/path0/pages/distributors/index.vue").then(m => m.default || m)
  },
  {
    name: _91id_93caSVL5ywX6Meta?.name ?? "families-id",
    path: _91id_93caSVL5ywX6Meta?.path ?? "/families/:id()",
    meta: _91id_93caSVL5ywX6Meta || {},
    alias: _91id_93caSVL5ywX6Meta?.alias || [],
    redirect: _91id_93caSVL5ywX6Meta?.redirect,
    component: () => import("/vercel/path0/pages/families/[id].vue").then(m => m.default || m)
  },
  {
    name: indexlnJqahZSogMeta?.name ?? "field-posts-id",
    path: indexlnJqahZSogMeta?.path ?? "/field-posts/:id()",
    meta: indexlnJqahZSogMeta || {},
    alias: indexlnJqahZSogMeta?.alias || [],
    redirect: indexlnJqahZSogMeta?.redirect,
    component: () => import("/vercel/path0/pages/field-posts/[id]/index.vue").then(m => m.default || m)
  },
  {
    name: _91iid_93kKcUuqGlq7Meta?.name ?? "field-posts-id-interventions-iid",
    path: _91iid_93kKcUuqGlq7Meta?.path ?? "/field-posts/:id()/interventions/:iid()",
    meta: _91iid_93kKcUuqGlq7Meta || {},
    alias: _91iid_93kKcUuqGlq7Meta?.alias || [],
    redirect: _91iid_93kKcUuqGlq7Meta?.redirect,
    component: () => import("/vercel/path0/pages/field-posts/[id]/interventions/[iid].vue").then(m => m.default || m)
  },
  {
    name: newUJDw7NQtVXMeta?.name ?? "field-posts-id-interventions-new",
    path: newUJDw7NQtVXMeta?.path ?? "/field-posts/:id()/interventions/new",
    meta: newUJDw7NQtVXMeta || {},
    alias: newUJDw7NQtVXMeta?.alias || [],
    redirect: newUJDw7NQtVXMeta?.redirect,
    component: () => import("/vercel/path0/pages/field-posts/[id]/interventions/new.vue").then(m => m.default || m)
  },
  {
    name: indexhGdnMdBQIJMeta?.name ?? "field-posts",
    path: indexhGdnMdBQIJMeta?.path ?? "/field-posts",
    meta: indexhGdnMdBQIJMeta || {},
    alias: indexhGdnMdBQIJMeta?.alias || [],
    redirect: indexhGdnMdBQIJMeta?.redirect,
    component: () => import("/vercel/path0/pages/field-posts/index.vue").then(m => m.default || m)
  },
  {
    name: indexe9Brt5DfdhMeta?.name ?? "index",
    path: indexe9Brt5DfdhMeta?.path ?? "/",
    meta: indexe9Brt5DfdhMeta || {},
    alias: indexe9Brt5DfdhMeta?.alias || [],
    redirect: indexe9Brt5DfdhMeta?.redirect,
    component: () => import("/vercel/path0/pages/index.vue").then(m => m.default || m)
  },
  {
    name: summaryw9kPgb09MjMeta?.name ?? "intervention-summary",
    path: summaryw9kPgb09MjMeta?.path ?? "/intervention/summary",
    meta: summaryw9kPgb09MjMeta || {},
    alias: summaryw9kPgb09MjMeta?.alias || [],
    redirect: summaryw9kPgb09MjMeta?.redirect,
    component: () => import("/vercel/path0/pages/intervention/summary.vue").then(m => m.default || m)
  },
  {
    name: invoicesOsO5xW78nEMeta?.name ?? "invoices",
    path: invoicesOsO5xW78nEMeta?.path ?? "/invoices",
    meta: invoicesOsO5xW78nEMeta || {},
    alias: invoicesOsO5xW78nEMeta?.alias || [],
    redirect: invoicesOsO5xW78nEMeta?.redirect,
    component: () => import("/vercel/path0/pages/invoices.vue").then(m => m.default || m),
    children: [
  {
    name: _91id_93iLwXZpucciMeta?.name ?? "invoices-partners-id",
    path: _91id_93iLwXZpucciMeta?.path ?? "partners/:id()",
    meta: _91id_93iLwXZpucciMeta || {},
    alias: _91id_93iLwXZpucciMeta?.alias || [],
    redirect: _91id_93iLwXZpucciMeta?.redirect,
    component: () => import("/vercel/path0/pages/invoices/partners/[id].vue").then(m => m.default || m)
  },
  {
    name: index6zufjfFsdpMeta?.name ?? "invoices-partners",
    path: index6zufjfFsdpMeta?.path ?? "partners",
    meta: index6zufjfFsdpMeta || {},
    alias: index6zufjfFsdpMeta?.alias || [],
    redirect: index6zufjfFsdpMeta?.redirect,
    component: () => import("/vercel/path0/pages/invoices/partners/index.vue").then(m => m.default || m)
  },
  {
    name: _91id_93zA9Q6fcuDNMeta?.name ?? "invoices-providers-id",
    path: _91id_93zA9Q6fcuDNMeta?.path ?? "providers/:id()",
    meta: _91id_93zA9Q6fcuDNMeta || {},
    alias: _91id_93zA9Q6fcuDNMeta?.alias || [],
    redirect: _91id_93zA9Q6fcuDNMeta?.redirect,
    component: () => import("/vercel/path0/pages/invoices/providers/[id].vue").then(m => m.default || m)
  },
  {
    name: indexrHd2qMcmoUMeta?.name ?? "invoices-providers",
    path: indexrHd2qMcmoUMeta?.path ?? "providers",
    meta: indexrHd2qMcmoUMeta || {},
    alias: indexrHd2qMcmoUMeta?.alias || [],
    redirect: indexrHd2qMcmoUMeta?.redirect,
    component: () => import("/vercel/path0/pages/invoices/providers/index.vue").then(m => m.default || m)
  }
]
  },
  {
    name: logint0AWlhQgM0Meta?.name ?? "login",
    path: logint0AWlhQgM0Meta?.path ?? "/login",
    meta: logint0AWlhQgM0Meta || {},
    alias: logint0AWlhQgM0Meta?.alias || [],
    redirect: logint0AWlhQgM0Meta?.redirect,
    component: () => import("/vercel/path0/pages/login.vue").then(m => m.default || m)
  },
  {
    name: indexYm59oj1SLUMeta?.name ?? "partners",
    path: indexYm59oj1SLUMeta?.path ?? "/partners",
    meta: indexYm59oj1SLUMeta || {},
    alias: indexYm59oj1SLUMeta?.alias || [],
    redirect: indexYm59oj1SLUMeta?.redirect,
    component: () => import("/vercel/path0/pages/partners/index.vue").then(m => m.default || m)
  },
  {
    name: forgotaWbLRONbBIMeta?.name ?? "password-forgot",
    path: forgotaWbLRONbBIMeta?.path ?? "/password/forgot",
    meta: forgotaWbLRONbBIMeta || {},
    alias: forgotaWbLRONbBIMeta?.alias || [],
    redirect: forgotaWbLRONbBIMeta?.redirect,
    component: () => import("/vercel/path0/pages/password/forgot.vue").then(m => m.default || m)
  },
  {
    name: resethWbKa6yAgnMeta?.name ?? "password-reset",
    path: resethWbKa6yAgnMeta?.path ?? "/password/reset",
    meta: resethWbKa6yAgnMeta || {},
    alias: resethWbKa6yAgnMeta?.alias || [],
    redirect: resethWbKa6yAgnMeta?.redirect,
    component: () => import("/vercel/path0/pages/password/reset.vue").then(m => m.default || m)
  },
  {
    name: verifyPiQwSCcsB1Meta?.name ?? "password-verify",
    path: verifyPiQwSCcsB1Meta?.path ?? "/password/verify",
    meta: verifyPiQwSCcsB1Meta || {},
    alias: verifyPiQwSCcsB1Meta?.alias || [],
    redirect: verifyPiQwSCcsB1Meta?.redirect,
    component: () => import("/vercel/path0/pages/password/verify.vue").then(m => m.default || m)
  },
  {
    name: _91id_93IrdWkC0qDNMeta?.name ?? "payments-id",
    path: _91id_93IrdWkC0qDNMeta?.path ?? "/payments/:id()",
    meta: _91id_93IrdWkC0qDNMeta || {},
    alias: _91id_93IrdWkC0qDNMeta?.alias || [],
    redirect: _91id_93IrdWkC0qDNMeta?.redirect,
    component: () => import("/vercel/path0/pages/payments/[id].vue").then(m => m.default || m)
  },
  {
    name: indexLuCZoHS5xNMeta?.name ?? "payments",
    path: indexLuCZoHS5xNMeta?.path ?? "/payments",
    meta: indexLuCZoHS5xNMeta || {},
    alias: indexLuCZoHS5xNMeta?.alias || [],
    redirect: indexLuCZoHS5xNMeta?.redirect,
    component: () => import("/vercel/path0/pages/payments/index.vue").then(m => m.default || m)
  },
  {
    name: indexGmBGSTDz3PMeta?.name ?? "reports",
    path: indexGmBGSTDz3PMeta?.path ?? "/reports",
    meta: indexGmBGSTDz3PMeta || {},
    alias: indexGmBGSTDz3PMeta?.alias || [],
    redirect: indexGmBGSTDz3PMeta?.redirect,
    component: () => import("/vercel/path0/pages/reports/index.vue").then(m => m.default || m)
  },
  {
    name: settingsyZZu4Rd1aAMeta?.name ?? "settings",
    path: settingsyZZu4Rd1aAMeta?.path ?? "/settings",
    meta: settingsyZZu4Rd1aAMeta || {},
    alias: settingsyZZu4Rd1aAMeta?.alias || [],
    redirect: settingsyZZu4Rd1aAMeta?.redirect,
    component: () => import("/vercel/path0/pages/settings.vue").then(m => m.default || m),
    children: [
  {
    name: field_45postsgruasRTqaaMeta?.name ?? "settings-field-posts",
    path: field_45postsgruasRTqaaMeta?.path ?? "field-posts",
    meta: field_45postsgruasRTqaaMeta || {},
    alias: field_45postsgruasRTqaaMeta?.alias || [],
    redirect: field_45postsgruasRTqaaMeta?.redirect,
    component: () => import("/vercel/path0/pages/settings/field-posts.vue").then(m => m.default || m)
  },
  {
    name: optionsBIMxQezTTkMeta?.name ?? "settings-options",
    path: optionsBIMxQezTTkMeta?.path ?? "options",
    meta: optionsBIMxQezTTkMeta || {},
    alias: optionsBIMxQezTTkMeta?.alias || [],
    redirect: optionsBIMxQezTTkMeta?.redirect,
    component: () => import("/vercel/path0/pages/settings/options.vue").then(m => m.default || m)
  },
  {
    name: productsuQXr0fzq6aMeta?.name ?? "settings-products",
    path: productsuQXr0fzq6aMeta?.path ?? "products",
    meta: productsuQXr0fzq6aMeta || {},
    alias: productsuQXr0fzq6aMeta?.alias || [],
    redirect: productsuQXr0fzq6aMeta?.redirect,
    component: () => import("/vercel/path0/pages/settings/products.vue").then(m => m.default || m)
  },
  {
    name: providersk3w8VFccXoMeta?.name ?? "settings-providers",
    path: providersk3w8VFccXoMeta?.path ?? "providers",
    meta: providersk3w8VFccXoMeta || {},
    alias: providersk3w8VFccXoMeta?.alias || [],
    redirect: providersk3w8VFccXoMeta?.redirect,
    component: () => import("/vercel/path0/pages/settings/providers.vue").then(m => m.default || m)
  },
  {
    name: usersh4j5PhVKwFMeta?.name ?? "settings-users",
    path: usersh4j5PhVKwFMeta?.path ?? "users",
    meta: usersh4j5PhVKwFMeta || {},
    alias: usersh4j5PhVKwFMeta?.alias || [],
    redirect: usersh4j5PhVKwFMeta?.redirect,
    component: () => import("/vercel/path0/pages/settings/users.vue").then(m => m.default || m)
  },
  {
    name: verifyMlHSZdr9flMeta?.name ?? "settings-verify",
    path: verifyMlHSZdr9flMeta?.path ?? "verify",
    meta: verifyMlHSZdr9flMeta || {},
    alias: verifyMlHSZdr9flMeta?.alias || [],
    redirect: verifyMlHSZdr9flMeta?.redirect,
    component: () => import("/vercel/path0/pages/settings/verify.vue").then(m => m.default || m)
  }
]
  },
  {
    name: telemedicineV1sC0qjAtGMeta?.name ?? undefined,
    path: telemedicineV1sC0qjAtGMeta?.path ?? "/telemedicine",
    meta: telemedicineV1sC0qjAtGMeta || {},
    alias: telemedicineV1sC0qjAtGMeta?.alias || [],
    redirect: telemedicineV1sC0qjAtGMeta?.redirect,
    component: () => import("/vercel/path0/pages/telemedicine.vue").then(m => m.default || m),
    children: [
  {
    name: indexuj64qDKGynMeta?.name ?? "telemedicine-doctors-id",
    path: indexuj64qDKGynMeta?.path ?? "doctors/:id()",
    meta: indexuj64qDKGynMeta || {},
    alias: indexuj64qDKGynMeta?.alias || [],
    redirect: indexuj64qDKGynMeta?.redirect,
    component: () => import("/vercel/path0/pages/telemedicine/doctors/[id]/index.vue").then(m => m.default || m)
  },
  {
    name: scheduleseHmwTKtEfMeta?.name ?? "telemedicine-doctors-id-schedule",
    path: scheduleseHmwTKtEfMeta?.path ?? "doctors/:id()/schedule",
    meta: scheduleseHmwTKtEfMeta || {},
    alias: scheduleseHmwTKtEfMeta?.alias || [],
    redirect: scheduleseHmwTKtEfMeta?.redirect,
    component: () => import("/vercel/path0/pages/telemedicine/doctors/[id]/schedule.vue").then(m => m.default || m)
  },
  {
    name: indexZ79RIZiHMxMeta?.name ?? "telemedicine-doctors",
    path: indexZ79RIZiHMxMeta?.path ?? "doctors",
    meta: indexZ79RIZiHMxMeta || {},
    alias: indexZ79RIZiHMxMeta?.alias || [],
    redirect: indexZ79RIZiHMxMeta?.redirect,
    component: () => import("/vercel/path0/pages/telemedicine/doctors/index.vue").then(m => m.default || m)
  },
  {
    name: indexOzhQKgPhzjMeta?.name ?? "telemedicine",
    path: indexOzhQKgPhzjMeta?.path ?? "",
    meta: indexOzhQKgPhzjMeta || {},
    alias: indexOzhQKgPhzjMeta?.alias || [],
    redirect: indexOzhQKgPhzjMeta?.redirect,
    component: () => import("/vercel/path0/pages/telemedicine/index.vue").then(m => m.default || m)
  },
  {
    name: profileTn0cRqXeAoMeta?.name ?? "telemedicine-profile",
    path: profileTn0cRqXeAoMeta?.path ?? "profile",
    meta: profileTn0cRqXeAoMeta || {},
    alias: profileTn0cRqXeAoMeta?.alias || [],
    redirect: profileTn0cRqXeAoMeta?.redirect,
    component: () => import("/vercel/path0/pages/telemedicine/profile.vue").then(m => m.default || m)
  },
  {
    name: schedulecvKCCGt34GMeta?.name ?? "telemedicine-schedule",
    path: schedulecvKCCGt34GMeta?.path ?? "schedule",
    meta: schedulecvKCCGt34GMeta || {},
    alias: schedulecvKCCGt34GMeta?.alias || [],
    redirect: schedulecvKCCGt34GMeta?.redirect,
    component: () => import("/vercel/path0/pages/telemedicine/schedule.vue").then(m => m.default || m)
  },
  {
    name: specialtiesLYpcaOE6QIMeta?.name ?? "telemedicine-specialties",
    path: specialtiesLYpcaOE6QIMeta?.path ?? "specialties",
    meta: specialtiesLYpcaOE6QIMeta || {},
    alias: specialtiesLYpcaOE6QIMeta?.alias || [],
    redirect: specialtiesLYpcaOE6QIMeta?.redirect,
    component: () => import("/vercel/path0/pages/telemedicine/specialties.vue").then(m => m.default || m)
  }
]
  },
  {
    name: viewPrQRR6i1T0Meta?.name ?? "transport-view",
    path: viewPrQRR6i1T0Meta?.path ?? "/transport/view",
    meta: viewPrQRR6i1T0Meta || {},
    alias: viewPrQRR6i1T0Meta?.alias || [],
    redirect: viewPrQRR6i1T0Meta?.redirect,
    component: () => import("/vercel/path0/pages/transport/view.vue").then(m => m.default || m)
  },
  {
    name: _91id_93oxadfVMr34Meta?.name ?? "transports-id",
    path: _91id_93oxadfVMr34Meta?.path ?? "/transports/:id()",
    meta: _91id_93oxadfVMr34Meta || {},
    alias: _91id_93oxadfVMr34Meta?.alias || [],
    redirect: _91id_93oxadfVMr34Meta?.redirect,
    component: () => import("/vercel/path0/pages/transports/[id].vue").then(m => m.default || m)
  },
  {
    name: createyIkZ1jIXbuMeta?.name ?? "transports-create",
    path: createyIkZ1jIXbuMeta?.path ?? "/transports/create",
    meta: createyIkZ1jIXbuMeta || {},
    alias: createyIkZ1jIXbuMeta?.alias || [],
    redirect: createyIkZ1jIXbuMeta?.redirect,
    component: () => import("/vercel/path0/pages/transports/create.vue").then(m => m.default || m)
  },
  {
    name: indexWVnZNZrOTzMeta?.name ?? "transports",
    path: indexWVnZNZrOTzMeta?.path ?? "/transports",
    meta: indexWVnZNZrOTzMeta || {},
    alias: indexWVnZNZrOTzMeta?.alias || [],
    redirect: indexWVnZNZrOTzMeta?.redirect,
    component: () => import("/vercel/path0/pages/transports/index.vue").then(m => m.default || m)
  },
  {
    name: indexOXtObJcgq9Meta?.name ?? "users",
    path: indexOXtObJcgq9Meta?.path ?? "/users",
    meta: indexOXtObJcgq9Meta || {},
    alias: indexOXtObJcgq9Meta?.alias || [],
    redirect: indexOXtObJcgq9Meta?.redirect,
    component: () => import("/vercel/path0/pages/users/index.vue").then(m => m.default || m)
  }
]